import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DisplayCard from "../../../../components/DisplayCard";
import collection_icon from "../../asserts/amount_credited.svg";
import disbursed_icon from "../../asserts/amount_debited.svg";
import school_icon from "../../asserts/school.svg";
import { dashboardContext } from "../../Dashboard";
import { LoadingSpinner } from "../School/pages/SchoolList";
import { useQuery } from "@apollo/client";
import { GET_TOTAL } from "../School/Querries";
function Overview() {
  const { data: schoolData, loading, error } = useQuery(GET_TOTAL);

  const [total, settotal] = useState<any>(null);
  const { total_collection } = useContext(dashboardContext);
  useEffect(() => {
    if (schoolData?.getallschool?.pagination) {
      settotal(schoolData.getallschool.pagination.total);
    }
  }, [schoolData]);
  if (error) {
    return (
      <div className="text-center py-8 text-red-500">
        Error loading school details
      </div>
    );
  }
  return (
    <div className="flex flex-col space-y-4">
      {loading ? (
        <LoadingSpinner />
      ) : (
        <>
          <div>
            <Link
              to="/create_school"
              className="px-4 py-2 bg-[#6F6AF8] rounded-md text-white float-right"
            >
              Create New School
            </Link>
          </div>
          <div className="flex gap-x-4">
            <DisplayCard
              width="max-w-md w-full"
              icon={school_icon}
              to="/school_profile"
              label="No. of Schools Onboarded"
              value={total || 0}
            />
          </div>

          <div className="flex gap-x-4">
            <DisplayCard
              width="w-2/5"
              icon={collection_icon}
              to="/amount-collected"
              label="Amount collected"
              value={`₹${
                total_collection?.total_collection?.toLocaleString("hi") || 0
              }`}
            />
            <DisplayCard
              width="w-2/5"
              icon={disbursed_icon}
              to="/amount-disbursed"
              label="Amount disbursed"
              value={`₹${(
                (total_collection?.total_collection || 0) -
                (total_collection?.total_collection || 0)
              )?.toLocaleString("hi")}`}
            />
            <DisplayCard
              width="w-2/5"
              icon={disbursed_icon}
              to="/school_profile"
              label="Amount Left To Be disbursed"
              value={`₹${
                total_collection?.total_collection?.toLocaleString("hi") || 0
              }`}
            />
          </div>

          <div className="flex gap-x-4 max-w-sm">
            <DisplayCard
              width="w-full"
              icon={collection_icon}
              to="/security-deposite"
              label="Have to Collect Security Deposit Amount"
              value={"21"}
            />
          </div>
        </>
      )}
    </div>
  );
}
export default Overview;
